import {createReducer} from '@reduxjs/toolkit';
import {
  setVisibleCollection,
  selectCollectionFeatures,
  setFeatureDetailsRef,
  setShowQuotaManagement,
} from '@src/actions/featureCollections.ts';
import {
  type FeatureRef,
  type FeatureCollectionId,
} from '@src/types/featureCollections.ts';

type FeatureCollectionsState = {
  featureDetailsRef: FeatureRef | null;
  selectedFeatures: FeatureRef[] | null;
  showQuotaManagement: boolean;
  visibleCollectionId: FeatureCollectionId | null;
};

export const initialState: FeatureCollectionsState = {
  // The feature ref to show details for
  featureDetailsRef: null,

  // The references of the currently selected features.
  selectedFeatures: [],

  // Whether we're in quota management mode
  showQuotaManagement: false,

  // The hash ID of the currently visible collection.
  visibleCollectionId: null,
};

export default createReducer(initialState, builder => {
  builder.addCase(selectCollectionFeatures, (state, {payload}) => {
    state.selectedFeatures = payload ?? [];
  });

  builder.addCase(setFeatureDetailsRef, (state, {payload}) => {
    state.featureDetailsRef = payload ?? null;
  });

  builder.addCase(setShowQuotaManagement, (state, {payload}) => {
    state.showQuotaManagement = !!payload;
  });

  builder.addCase(setVisibleCollection, (state, {payload}) => {
    state.visibleCollectionId = payload ?? null;
  });
});
